module.exports = __webpack_public_path__ + "static/img/competition_back.2914927d.png";